<template>
  <div class="flex place-content-end text-text-90 metrics">
    <span v-if="metricType !== 'characters'" data-testid="words-count">Words: {{ wordsCount }}</span>
    <span class="ml-2" data-testid="characters-count">
      Characters:
      <span
        data-testid="current-characters-count"
        :class="{ 'text-error-100': hasExceededMaxCharacters }"
      >
        {{ charactersCount }}
      </span>
      <span v-if="maxCharacters" data-testid="max-characters">/{{ maxCharacters }}</span>
      <span v-if="minCharacters" data-testid="min-characters"> (min {{ minCharacters }})</span>
    </span>
  </div>
</template>
<script setup lang="ts">
export interface Props {
  wordsCount: number;
  charactersCount: number;
  maxCharacters?: number;
  minCharacters?: number;
  metricType?: "words" | "characters";
}

const props = defineProps<Props>();

const hasExceededMaxCharacters = computed(
  () => !!props.maxCharacters && props.maxCharacters > 0 && props.charactersCount > props.maxCharacters
);
</script>
<style scoped lang="scss">
@import "@/assets/scss/utilities";

.metrics {
  @include font-semibold(12);
}
</style>
